export default class DownPaymentInfo{
    id= 1;
    receiptNo= "-";
    orderNo= "-";

    constructor(params?: Partial<DownPaymentInfo>){
        Object.assign(this,{...params});
    }
}